const getMeta = require('./getMeta');
const parseRmUrl = require('./parseRmUrl');

const csrfToken = getMeta("csrf-token");

module.exports = function (uri, init) {
    return fetch(parseRmUrl(uri).href, {
        ...init,
        headers: {
            ..._.get(init, 'headers'),
            'X-CSRF-TOKEN': csrfToken,
        },
        credentials: 'same-origin',
    });
};
